import { render, staticRenderFns } from "./UsersInvitationsRow.vue?vue&type=template&id=97952c12&scoped=true&"
import script from "./UsersInvitationsRow.vue?vue&type=script&lang=js&"
export * from "./UsersInvitationsRow.vue?vue&type=script&lang=js&"
import style0 from "./UsersInvitationsRow.vue?vue&type=style&index=0&id=97952c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97952c12",
  null
  
)

export default component.exports